import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation } from "@tanstack/react-query";

import { saveDataRequestEntityFreeTextMutation } from "./data-request.gql";

interface SaveEntityFreeTextResponse {
  saveDataRequestEntityFreeText: { id: string; freeTextAnswers: Record<string, string> | null };
}

export interface SaveEntityFreeTextInput {
  dataRequestEntityId: string;
  answers?: Record<string, string>;
}

export const useSaveEntityFreeTextMutation = () => {
  const mutation = useMutation({
    mutationFn: async (input: SaveEntityFreeTextInput) => {
      const client = createOperationClient("SaveDataRequestEntityFreeText");
      const data = await client.request<SaveEntityFreeTextResponse>(saveDataRequestEntityFreeTextMutation, {
        input,
      });
      return data.saveDataRequestEntityFreeText;
    },
  });

  return {
    saveFreeText: mutation.mutate,
    saveFreeTextAsync: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
